import { Solution } from "../solution";

export function containSolutionById(solutions: Solution[], solutionId: string):boolean {
    for (const solution of solutions) {
        if (solution.getId() === solutionId) {
            return true;
        }
    }

    return false;
}